import makeVueModal from '@/views/modal/make_vue_modal';

import inNewTab from '@/helpers/in_new_tab';
import showModal from '@/utils/show_modal';
import track from '@/helpers/track';
import { isMobile } from '@/helpers/mobile_detect';

let popupModals = {};
let contactsModal = null;
let localeSwitcherModal = null;
let authModal = null;

$(document).on('turbolinks:before-cache', () => {
  Object.values(popupModals).forEach(modal => {
    modal.hide();
    modal.destroy();
  });
  popupModals = {};

  if (contactsModal) {
    contactsModal.destroy();
    contactsModal = null;
  }

  if (localeSwitcherModal) {
    localeSwitcherModal.destroy();
    localeSwitcherModal = null;
  }

  if (authModal) {
    authModal.destroy();
    authModal = null;
  }
});

$(document).on('turbolinks:load', () => {
  if (!document.body.className.includes('v4')) { return; }

  $('.b-top_menu.v4 [data-popup]').on('click', e => {
    const isMobileOnly = e.currentTarget.hasAttribute('data-popup-mobile-only');

    if (isMobileOnly && !isMobile()) {
      return;
    }

    e.preventDefault();
    const { currentTarget } = e;
    const $trigger = $(currentTarget);
    const popupSelector = $trigger.data('popup');

    popupModals[popupSelector] ||= showModal({
      $modal: $(popupSelector),
      $trigger,
      show() {
        $(popupSelector).addClass('is-active');
      },
      hide() {
        $(popupSelector).removeClass('is-active');
      },
      isHiddenCheck() {
        return !$(popupSelector).hasClass('is-active');
      }
    })
      .show();
  });

  $('.b-top_menu.v4 .contacts-modal-trigger').one('click', async ({ currentTarget }) => {
    const $node = $(currentTarget);

    contactsModal ||= makeVueModal({
      trigger: currentTarget,
      cssClass: 'slide-from-edge',
      vue: {
        importComponent: async () => await import('@/vue/modals/contacts'),
        props: {
          submitUrl: $node.data('submit_url'),
          leadType: $node.data('lead-type'),
          trackEvent: $node.data('track-event'),
          trackEventLocation: $node.data('track-event-location'),
          privacyUrl: $node.data('privacy_url'),
          privacyConsentUrl: $node.data('privacy_consent_url'),
          phoneUrl: $node.data('phone_url'),
          lineUrl: $node.data('line_url'),
          whatsappUrl: $node.data('whatsapp_url'),
          telegramUrl: $node.data('telegram_url'),
          maxUrl: $node.data('max_url'),
          workTime: $node.data('work_time'),
          faqUrl: $node.data('faq_url'),
          graphqlUrl: $node.data('graphql_url')
        }
      },
      onShow: () => {
        track({
          event: 'DEV_top_menu_contacts_modal',
          form_location: $node.data('track-event-location')
        });
      }
    })
      .show();
  });

  $('.b-top_menu.v4 .support-phone').on('click', event => {
    if (inNewTab(event)) { return; }
    event.preventDefault();

    $('.b-top_menu.v4 .contacts-modal-trigger').click();
  });

  $('.b-top_menu.v4 .locale_switcher-modal-trigger').one('click', async ({ currentTarget }) => {
    localeSwitcherModal ||= makeVueModal({
      trigger: currentTarget,
      cssClass: isMobile() ? 'slide-from-edge' : undefined,
      vue: {
        importComponent: async () => await import('@/vue/modals/locale_switcher')
      }
    })
      .show();
  });

  $('.b-top_menu.v4 .auth').on('click', async e => {
    e.preventDefault();

    const $trigger = $(e.currentTarget);

    if (authModal) {
      authModal.destroy();
    }

    authModal = makeVueModal({
      trigger: $trigger[0],
      cssClass: isMobile() ? 'slide-from-edge' : undefined,
      vue: {
        importComponent: async () => await import('@/vue/modals/auth'),
        props: {
          graphqlUrl: $trigger.data('graphql_url'),
          confirmationUrl: $trigger.data('confirmation_url'),
          confirmationType: $trigger.data('confirmation_type'),
          resendCodeInterval: $trigger.data('resend_code_interval'),
          nextUrl: $trigger.data('next_url'),
          isSignInTab: true,
          privacyUrl: $trigger.data('privacy_url'),
          privacyConsentUrl: $trigger.data('privacy_consent_url')
        }
      },
      isModalCloseHandler: true
      // onShow: () => {
      //   const { trackEventLocation } = $(currentTarget).data();
      //   track({ event: 'callback_form_opened', data: trackEventLocation });
      // }
    })
      .show();
  });
});
